<template>
  <div class="app">
    <app-header :hotel-name="hotelName" />

    <main class="main">
      <mine-view v-if="store.view === 'mine'" />
      <menu-view v-else-if="store.catId != null" />
      <landing-view v-else />
    </main>

    <dish-detail />
  </div>
</template>

<script>
import { HOTEL_NAME } from '@/data'
import { store, init, setWide } from '@/store'
import AppHeader from '@/components/AppHeader.vue'
import LandingView from '@/components/LandingView.vue'
import MenuView from '@/components/MenuView.vue'
import MineView from '@/components/MineView.vue'
import DishDetail from '@/components/DishDetail.vue'

export default {
  name: 'App',
  components: { AppHeader, LandingView, MenuView, MineView, DishDetail },
  data() {
    return { store, hotelName: HOTEL_NAME }
  },
  created() {
    init()
  },
  mounted() {
    this._onResize = () => setWide(window.innerWidth >= 760)
    window.addEventListener('resize', this._onResize)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this._onResize)
  }
}
</script>

<style>
@import '@/assets/tokens.css';

.app {
  min-height: 100vh;
  background: var(--color-bg);
  font-family: var(--font-sans);
  color: var(--ink-900);
  -webkit-font-smoothing: antialiased;
}
.main {
  max-width: 1180px;
  margin: 0 auto;
  padding: clamp(16px, 3vw, 28px) clamp(16px, 4vw, 40px) 80px;
}
</style>
